import { defineStore } from 'pinia';
import { useCache } from '@/hooks/useCache';
import { GetDictionaryCacheMapApi } from '@/apis/sys_dictionary/dictionary.api';

const { wsCache } = useCache();

const CacheKey = 'DictionaryCacheList';

export const useDictionary = defineStore('dictionary_maps', {
	state: (): any => ({
		dictionaryList: [] as any[],
		dictionaryMap: {} as any,
	}),
	actions: {
		getName(key: string, value: string | number) {
			if (!(key && value)) return;
			return this.dictionaryMap.get(`${key}|${value}`) ?? '--';
		},
		/* 获取选择列表 */
		getSelectList(key: string, needAll?: false) {
			const selectList = [];
			if (needAll) selectList.push({ value: '', label: '全部', code: '' });

			this.dictionaryList
				.filter((dic: any) => dic.group_code == key && dic.can_select == true)
				.forEach((dic: any) => {
					selectList.push({ value: dic.value, label: dic.key, code: dic.code });
				});

			return selectList;
		},
		/* 组装数据字典 */
		async setDictionaryMap() {
			wsCache.delete(CacheKey);
			
			let dicList = wsCache.get(CacheKey) || [];

			if (dicList.length <= 0) {
				dicList = await this.getDictionaryList();
			}
			//console.log(dicList);
			this.dictionaryList = dicList;

			/* 组装Map，格式：group_code|value */
			this.dictionaryMap = new Map();
			dicList.forEach((dic: any) => {
				this.dictionaryMap.set(`${dic.group_code}|${dic.value}`, dic.key);
			});
		},
		/* 读取字典数据 */
		getDictionaryList() {
			return new Promise((resolve) => {
				GetDictionaryCacheMapApi().then((res: any) => {
					const dicList = res.data || [];
					wsCache.set(CacheKey, dicList);
					resolve(dicList);
				});
			});
		},
	},
});
